<template>
    <transition name="redeem-success-fade">
        <div class="redeem-success" v-if="show" role="dialog" aria-modal="true">
            <div class="redeem-success-panel">
                <confetti-rain :show="show" />

                <div class="redeem-success-content">
                    <div class="redeem-success-slot">
                        <reward-card class="redeem-success-card" :reward="reward" plain />
                    </div>

                    <div class="redeem-success-text">
                        <h2 class="redeem-success-title" v-lang="'dashboard-redeemSuccessTitle'"></h2>

                        <p class="redeem-success-message">{{ message }}</p>

                        <button
                            type="button"
                            class="redeem-success-button"
                            @click="closeRedeemSuccess"
                            v-lang="'dashboard-redeemSuccessHome'"
                        ></button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import ConfettiRain from "../../shared/confetti-rain";
import RewardCard from "./points-reward-card";

export default {
    name: "RedeemSuccess",
    components: { ConfettiRain, RewardCard },
    computed: {
        ...mapState({
            redeemed: (state) => state.redeemed,
        }),
        show() {
            return !!this.redeemed;
        },
        reward() {
            return (this.redeemed && this.redeemed.reward) || {};
        },
        message() {
            return (this.redeemed && this.redeemed.message) || "";
        },
    },
    watch: {
        show() {
            this.setScrollLock(this.show);
        },
    },
    mounted() {
        document.addEventListener("keydown", this.onKeydown);
    },
    beforeDestroy() {
        document.removeEventListener("keydown", this.onKeydown);
        this.setScrollLock(false);
    },
    methods: {
        ...mapMutations(["closeRedeemSuccess"]),
        setScrollLock(locked) {
            const value = locked ? "hidden" : "";

            document.documentElement.style.overflow = value;
            document.body.style.overflow = value;
        },
        onKeydown(event) {
            if (this.show && (event.key === "Escape" || event.keyCode === 27)) {
                this.closeRedeemSuccess();
            }
        },
    },
};
</script>

<style lang="scss">
.redeem-success {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 200;
  display: flex;
}

.redeem-success-panel {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  overflow: hidden;
  background: #0b9055;
}

.redeem-success-panel .confetti-rain {
  position: absolute;
  z-index: 0;
}

.redeem-success-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 18.75rem;
  max-height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.redeem-success-slot {
  display: flex;
  align-items: center;
  min-height: 9.3125rem;
}

.redeem-success-card {
  animation: redeem-success-grow 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) 0.15s both;
}

.redeem-success-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}

.redeem-success-title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.3;
  color: #fcfcfd;
  text-align: center;
  overflow-wrap: anywhere;
}

.redeem-success-message {
  margin: 0;
  max-width: 15.5625rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.3;
  color: #fcfcfd;
  text-align: center;
  overflow-wrap: anywhere;
}

.redeem-success-button {
  width: 100%;
  min-height: 2.6875rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  background: #fcfcfd;
  color: #1f2a37;
  font-size: 1rem;
  line-height: 1.2;
  cursor: pointer;
  transition: transform 0.1s;

  &:active {
    transform: scale(0.98);
  }
}

@media (min-width: 48rem) {
  .redeem-success {
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
    background: rgba(13, 18, 28, 0.55);
  }

  .redeem-success-panel {
    max-width: 56.25rem;
    height: 50.75rem;
    max-height: 100%;
    border-radius: 1.5rem;
    box-shadow: 0 1.5rem 3rem rgba(0, 0, 0, 0.25);
  }
}

@keyframes redeem-success-grow {
  from {
    opacity: 0;
    transform: scale(0.2);
  }

  60% {
    opacity: 1;
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .redeem-success-card {
    animation: none;
  }
}

.redeem-success-fade-enter-active,
.redeem-success-fade-leave-active {
  transition: opacity 0.25s ease;
}

.redeem-success-fade-enter,
.redeem-success-fade-leave-to {
  opacity: 0;
}
</style>
